import {UPDATE_CARTONS_FUNCTION_URL} from '@/constants.js'
import firebase from "firebase/app";
function updateCartons(cartons, idToken) {
    // verify for dev environment
    if (process.env.VUE_APP_ENV === "dev") {
        let db = firebase.firestore();
        let batch = db.batch();
        Object.keys(cartons).forEach((cartonId) => {
            let normId = cartonId.replaceAll("/", "-").toUpperCase();
            let cartonRef = db.collection("cartons").doc(normId);
            let carton = cartons[cartonId];
            let carton_copy = {...carton};
            // find for items names that starts with "ARRAY_UNION.field_name" and convert them to firebase.firestore.FieldValue.arrayUnion
            Object.keys(carton).forEach((key) => {
                if (key.startsWith("ARRAY_UNION.")) {
                    let field_name = key.replace("ARRAY_UNION.", "");
                    carton_copy[field_name] = firebase.firestore.FieldValue.arrayUnion({...carton[key]});
                    delete carton_copy[key];
                }
                else {
                    carton_copy[key] = carton[key];
                }
            });
            console.log("Updating carton: ", cartonId, carton_copy);
            batch.set(cartonRef, carton_copy,{ merge: true });
        });
        batch.commit();
        return new Promise((resolve) => {
            console.log("Cartons updated: ", cartons);
            resolve();
        });
    }
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${idToken}`);
    const normCartons = {};
    Object.keys(cartons).forEach((cartonId) => {
      normCartons[cartonId.replaceAll("/", "-").toUpperCase()] = cartons[cartonId];
    });
    const body = { "cartons": normCartons }
    const raw = JSON.stringify(body);

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };

    return fetch(UPDATE_CARTONS_FUNCTION_URL, requestOptions);
}
export {updateCartons}